export default "__VITE_ASSET__BsV36pMh__"